<div class="upsell-faq bg-dmp-cream py-8">
  <div class="upsell-faq__container w-full mx-auto p-4">
    <h2 class="upsell-faq__title text-3xl font-bold text-center desktop:text-left mb-8" [innerHTML]="upsellFaqTitle"></h2>

    @for (item of upsellFaqContent; track $index; let i = $index) {
      <div class="upsell-faq__questions mb-4">
        <div class="upsell-faq__question flex items-center justify-between cursor-pointer hover:opacity-80 transition-opacity" (click)="toggleFaq(i)">
          <div class="text-2xl font-bold flex-1" [innerHTML]="item.question"></div>
          <!-- up/down arrow -->
          <span class="w-6 h-6 flex items-center justify-center transition-transform duration-500" [class.rotate-180]="isExpanded(i)"><svg class="w-5 h-5" viewBox="0 0 16 16" fill="none"><path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        </div>
        <div class="upsell-faq__answer overflow-hidden transition-all duration-500" [class.max-h-0]="!isExpanded(i)" [class.max-h-96]="isExpanded(i)" [class.opacity-0]="!isExpanded(i)" [class.opacity-100]="isExpanded(i)">
          <div class="text-lg mt-3" [innerHTML]="item.answer"></div>
        </div>
        @if (i < upsellFaqContent.length - 1) {
          <hr class="mt-4 border-gray-500">
        }
      </div>
    }
  </div>
</div>
